<template>
  <div class="login">
    <div class="dialog">
      <div class="content">
        <img class="logo_resetpassword" src="../assets/login_logo.png">
        <input id="mailInput" type="text" placeholder="メールアドレス" v-model="email">
        <div id="loginLinkArea">
          <router-link id="loginLink" to="/login">ログイン画面にもどる</router-link>
        </div>

        <!--
        <div class="loginButton" @click="logIn"><button>ログイン</button></div>
        -->

        <button class="loginButton" :class="{disabled: isButtonDisabled}" @click="doReset">パスワード再設定リンクを送る</button>
      </div>

    </div>

    <div class="loadingBackground" v-if="isLoading">
      <div class="loadingDialog">
        <half-circle-spinner
          :animation-duration="1000"
          :size="60"
          :color="'#ffffff'"
        />
      </div>
    </div>

  </div>
</template>

<script>
  import {db, auth} from '../firebase'
  import {HalfCircleSpinner} from 'epic-spinners'

  export default {
    name: 'ResetPassword',

    components: {
      HalfCircleSpinner
    },

    data() {
      return {
        email: '',

        companies: [],

        isLoading: false,
      }
    },

    computed: {

      isButtonDisabled() {
        return !this.email;
      }
    },

    methods: {
      async doReset() {
        this.isLoading = true
        try {
          var actionCodeSettings = {
            url: 'http://localhost:8080/login?email=' + this.email,

            handleCodeInApp: false,
            // When multiple custom dynamic link domains are defined, specify which
            // one to use.
            //dynamicLinkDomain: "example.page.link"
          };

          auth.languageCode = 'ja';
          await auth.sendPasswordResetEmail(this.email, actionCodeSettings)
          console.log('Reset password email is sent to the following address', this.email)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
        }
      },

    },
    mounted() {


    },
    firestore: {
      companies: db.collection('companies')
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .login {
    /*
    margin-top: 0px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    */

    width: 100%;
    height: 100vh;
  }


  .dialog {

    /* https://stackoverflow.com/a/14816807/1709287 */
    width: 480px;
    height: 600px;

    background-color: white;

    position: absolute; /*it can be fixed too*/
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;

    /*this to solve "the content will not be cut when the window is smaller than the content": */
    max-width: 100%;
    max-height: 100%;
    overflow: auto;

    border-radius: 35px;
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;


    margin-top: 3%;

  }

  .content {
    width: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: white;
  }

  .logo_resetpassword {
    max-width: 50%;
    margin: 50px auto 0 auto;
    position: auto;

  }

  input {
    width: 340px;
    height: 28px;
    padding: 10px;
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
    box-shadow: 0 0 0 #D2D2D2;
  }

  input:focus {
    outline: none !important;
    border: 2px solid #D2FF00;
    box-shadow: 0 0 0 #D2FF00;
  }

  #mailInput {
    margin-top: 47px;
  }

  #passwordInput {
    margin-top: 10px;
  }

  #loginLinkArea {
    width: 340px;
    text-align: right;
    margin-top: 0;
  }

  #loginLink {
    color: #9EC002;
    font-size: 14px;
    font-weight: bold;
  }


  .loginButton {
    width: 350px;
    height: 42px;
    background-color: #D2FF00;
    color: #5C5C5C;
    font-size: 18px;
    border-radius: 35px;
    margin-top: 50px;
    outline: none;

    border-style: solid;
    border-color: Transparent;
    border-width: 2px;
  }


  .loginButton:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #C7D931;
  }


  button.disabled {
    background-color: #D2D2D2;
  }


  button.disabled:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
  }

  @media (max-width: 768px) {

    .login {
      background-color: #ffffff;

    }

    .dialog {

      /* https://stackoverflow.com/a/14816807/1709287 */
      width: 100%;
      height: 100%;

      background-color: white;

      position: auto; /*it can be fixed too*/
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: 2%;

      /*this to solve "the content will not be cut when the window is smaller than the content": */
      max-width: 90%;
      max-height: 100%;
      overflow: auto;

      border-radius: 35px;
      border-style: solid;
      border-width: 0;

      margin-top: 3%;

    }

    .content {
      width: 100%;
      padding: 5px;
      margin: 5px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      background-color: white;
    }

    .loginButton {
      width: 280px;
      height: 42px;
      background-color: #D2FF00;
      color: #5C5C5C;
      font-size: 18px;
      border-radius: 35px;
      margin-top: 50px;
      outline: none;

      border-style: solid;
      border-color: Transparent;
      border-width: 2px;
    }

    input {
      width: 260px;
      height: 28px;
      padding: 3px;
      border-style: solid;
      border-width: 2px;
      border-color: #D2D2D2;
      box-shadow: 0 0 0 #D2D2D2;
    }

    #loginLink {
      color: #9EC002;
      font-size: 14px;
      font-weight: bold;
      margin-right: 2%;
    }

    #loginLinkArea {
      width: 260px;
      text-align: right;
      margin-top: 0;
    }


  }
</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword.vue